import React from 'react';
import { observer } from 'mobx-react';
// import advSearchState from 'Stores/advSearch';
import { myLeadsState } from 'Stores/myLeads';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import ContactEmailScore from 'Components/common/ContactList/contactEmailScore';
import CheckBox from 'Components/common/CheckBox';
import ContactIndustry from 'Components/common/ContactList/ContactIndustry';
import advSearchState from 'Stores/advSearch';
import { ReactComponent as AddToListIcon } from 'Assets/svg/add-to-list.svg';
import { ReactComponent as ContactEmailIcon } from 'Assets/svg/contact-email.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { ReactComponent as DownloadIcon } from 'Assets/svg/download.svg';
import { ReactComponent as ArchivedIcon } from 'Assets/svg/archive-icon.svg';
import {
  AddToListWithOptions,
  addToListWithOptionsState,
} from 'Pages/advancedSearch/AddToListWithOptions';
import ProcessingMessage from '../../processingMessage';
import { ContactCompany } from './contactCompany';
import { ContactEmailPhone } from './contactEmailPhone';
import { ContactName } from './contactName';

const MyLeadsListLoadingPlaceHolder = ({ currentTab }) => {
  return (
    <div className="contact-list">
      <div className="my-leads-list-placeholder">
        <div className="contact-list-wrap">
          {Array(15)
            .fill()
            .map((item, index) => {
              return (
                <div
                  className={`contact-item  ${
                    currentTab === 1
                      ? 'contact-loader-job-change'
                      : 'contact-items-for-loader'
                  }`}
                  key={index}
                >
                  <div className="contact-check-box-wrap">
                    <div className="common-check-box linear-background" />
                  </div>
                  <div className="contact-name">
                    <div className="name linear-background" />
                    <div className="title linear-background" />
                    <div className="contact-address-info linear-background" />
                  </div>
                  <div className="company-name">
                    <div className="name linear-background" />
                    <div className="company-address-info linear-background" />
                  </div>
                  <div className="company-name">
                    <div className="name linear-background" />
                    <div className="company-address-info linear-background" />
                  </div>

                  <div className="contact-info ">
                    <div className="contact-email">
                      <div className="info-icon linear-background" />
                      <div className="contact-email-copy-wrap linear-background" />
                    </div>
                    <div className="contact-email">
                      <div className="info-icon linear-background" />
                      <div className="contact-email-copy-wrap linear-background" />
                    </div>
                  </div>

                  {currentTab === 1 && (
                    <div className="action-button linear-background" />
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const ContactList = observer(props => {
  const {
    data,
    isListLoading = false,
    currentTab = null,
    setContactId,
    listId,
    LOCATION_PREFERENCE,
    currentListInfo = {},
  } = props;
  const { archivedCount = 0 } = currentListInfo;
  const [showAddToListSinglePop, setShowAddToListSinglePop] = React.useState(
    false,
  );

  const { featureFlags, userInfo, isFreeTrial } = userDetail;
  const { LEAD_BUILDER = false } = featureFlags;

  const contactSelection = (e, index) => {
    myLeadsState.updateSelectedBulkContactIds(index);
  };

  const addSingleItemToList = (e, id) => {
    advSearchState.setBulkPurchaseIds([id]);
    // this action wont work properly, its part of now disabled job changes
    addToListWithOptionsState.setShowListPopup(true);
  };
  const closeActionMask = () => {
    setShowAddToListSinglePop(false);
  };

  const downloadContact = (e, id, isDownloaded) => {
    if (LEAD_BUILDER === false) {
      Utils.showUserPricingPopup(true, '', true);
    } else if (isDownloaded) {
      myLeadsState.setActionLoader(true);

      myLeadsState.purchaseContactsForMyLeads({
        ids: [id],
        listId: myLeadsState.selectedList.id,
        callback: () => {
          myLeadsState.setActionLoader(false);
        },
        type: CONSTANTS.CONTACT_EXPORT_TYPES.DIRECT_EXPORT,
        exportType: 'CSV',
      });
    } else if (!Utils.isCreditBasedSubscription() && userInfo.downloads <= 0) {
      if (
        userInfo.memberSubscription !== null &&
        userInfo.memberSubscription !== undefined
      )
        Utils.showCreditExpiredPopup('downloads');
      else Utils.showUserPricingPopup(true, 'downloads', false);
    } else {
      myLeadsState.setActionLoader(true);
      myLeadsState.purchaseContactsForMyLeads({
        ids: [id],
        listId: myLeadsState.selectedList.id,
        callback: () => {
          myLeadsState.setActionLoader(false);
        },
        type: CONSTANTS.CONTACT_EXPORT_TYPES.DIRECT_EXPORT,
        exportType: 'CSV',
      });
    }
  };
  const purchaseContact = (e, id) => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_CONTACT_UPDATE_EVENTS.JOB_CHANGE_VIEW_CONTACT,
    );
    Utils.totangoTrack(
      CONSTANTS.TOTANGO.EVENTS.PURCHASE,
      CONSTANTS.TOTANGO.MODULES.MY_LEADS,
    );

    if (userInfo.userStatus === 0)
      if (LEAD_BUILDER === false) {
        Utils.showUserPricingPopup(true, '', true);
      } else if (
        !Utils.isPaygPlan() &&
        ((!Utils.isCreditBasedSubscription() && userInfo.views <= 0) ||
          (Utils.isCreditBasedSubscription() &&
            (userInfo.lbCredits <= 0 || !Utils.isCreditsWithinMonthlyLimit())))
      ) {
        if (
          userInfo.memberSubscription !== null &&
          userInfo.memberSubscription !== undefined
        )
          Utils.showCreditExpiredPopup('views');
        else Utils.showUserPricingPopup(true, 'views', false);
      } else {
        const callback = () => {
          myLeadsState.setActionLoader(true);
          const singleContactPurchaseCallback = () => {
            myLeadsState.setActionLoader(false);
          };
          myLeadsState.purchaseContactsForMyLeads({
            ids: [id],
            listId,
            callback: singleContactPurchaseCallback,
          });
        };
        Utils.checkUserHasEnoughCredits(1, 'view contact', callback);
      }
    else Utils.showEmailConfirmationPopup(userInfo.email);
  };

  const listView = data.map((item, index) => {
    const isContactWithoutEmail =
      item.status === 'ACTIVE_WITHOUT_EMAIL' ||
      item.status === 'ACTIVE_WITHOUT_EMAIL_PHONE';

    const isOwned = item.owned || isContactWithoutEmail;
    const score = item.emailConfidenceV2;
    return (
      <div className="contact-item-main" key={item.id}>
        <div
          className={`contact-item ${
            currentTab === 1
              ? 'contact-items-job-change'
              : 'contact-items-for-myLeads'
          }`}
          key={index}
        >
          <div className="contact-check-box-wrap">
            <CheckBox
              dymamicClass={item.checked ? 'selected' : ''}
              onClick={e => contactSelection(e, index)}
            />
          </div>
          <ContactName
            name={`${item.firstName}${
              item.lastName !== null && item.lastName !== undefined
                ? ` ${item.lastName}`
                : ''
            }`}
            title={item.title}
            facebookId={item.facebookId}
            twitterId={item.twitterId}
            linkedInId={item.linkedInId}
            updatesCount={item.updatesCount}
            diff={item?.diff}
            newLinkedInId={item?.diff?.linkedInURL?.newValue}
            cname={item.company?.name}
            allUpdatedFlag={item.allUpdatedFlag}
            contactCity={item.address?.city}
            contactState={item.address?.state}
            contactCountry={item.address?.country}
            companyCity={item.company?.city}
            companyState={item.company?.state}
            companyCountry={item.company?.country}
            contactId={item.id}
            email={item.email}
            phone={item.phoneScoreEntity}
            status={item.status}
            newTitle={item?.diff?.title?.newValue}
            previousTitle={item?.diff?.title?.oldValue}
            newContactState={item?.diff?.state?.newValue}
            newContactCity={item?.diff?.city?.newValue}
            newContactCountry={item?.diff?.country?.newValue}
            currentTab={currentTab}
            owned={currentTab === 1 ? isOwned : true}
            purchaseContact={() => purchaseContact(this, item.id)}
            LOCATION_PREFERENCE={LOCATION_PREFERENCE}
            phoneNumberFromVendor={item.phoneNumberFromVendor}
            score={score}
          />
          <ContactCompany
            cname={item.company?.name}
            companyCountry={item.company?.country}
            companyState={item.company?.state}
            companyCity={item.company?.city}
            companyId={item.company?.id}
            previousCompany={item?.diff?.companyName?.oldValue}
            companyLogo={item.company?.logoUrl}
            previousCompanyId={item?.diff?.companyId?.oldValue}
            previousCompanyLogo={item?.diff?.logo?.oldValue}
            movedDifferentTag={item.activeContacts}
            currentTab={currentTab}
            companyPhone={item.company?.phone}
            company={item?.company || {}}
          />
          <ContactIndustry
            contactId={item.id}
            industry={item.company?.industry}
            employeeCount={item.company?.headCount}
            revenue={item.company?.revenue}
          />
          <ContactEmailPhone
            contactId={item.id}
            email={item.email}
            isNewEmailAvailable={!!item?.diff?.email?.newValue}
            purchaseContactFunc={() => purchaseContact(this, item.id)}
            allUpdatedFlag={item.allUpdatedFlag}
            phone={item.phoneScoreEntity}
            phoneNumberFromVendor={item.phoneNumberFromVendor}
            status={item.status}
            previousPhoneEntity={[
              { type: 'D', value: item?.diff?.phoneDirect },
              { type: 'M', value: item?.diff?.phoneMobile },
              { type: 'O', value: item?.diff?.phoneOther },
              { type: 'C', value: item?.diff?.phoneCompany },
            ]}
            isDownloaded={currentTab === 1 ? isOwned : true}
            currentTab={currentTab}
            score={score}
          />

          {currentTab === 1 && (
            <div className="contact-action">
              {isOwned ? (
                <div className="contact-action-btn-wrap contact-action-multi-btn-wrap">
                  <div
                    className={`contact-action-btn add-to-list  add-to-list-icon ${
                      index === 0 ? ' add-to-list-first-contact' : ''
                    }`}
                    onClick={e => addSingleItemToList(e, item.id)}
                    data-id={item.id}
                  >
                    <AddToListIcon className="svg-icon job-changes-icons" />
                    <div className="copy-tooltip-wrap">
                      <span className="copy-tooltip">Add to List</span>
                      <span className="sharp-point" />
                    </div>
                  </div>
                  {!isContactWithoutEmail && (
                    <div
                      className="contact-action-btn download add-to-list-icon"
                      onClick={() =>
                        downloadContact(this, item.id, item.downloaded)
                      }
                    >
                      <DownloadIcon className="svg-icon job-changes-icons" />
                      <div className="copy-tooltip-wrap">
                        <span className="copy-tooltip">Download</span>
                        <span className="sharp-point" />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="contact-action-btn-wrap">
                  <div
                    className="contact-action-btn view-contact viewContactSingleLB"
                    onClick={() => purchaseContact(this, item.id)}
                  >
                    <ContactEmailIcon />
                    Find Email
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  });
  return isListLoading ? (
    <MyLeadsListLoadingPlaceHolder currentTab={currentTab} />
  ) : (
    <div className="contact-list">
      <div className="contact-list-wrap">
        <div
          className={`single-action-mask ${
            showAddToListSinglePop ? 'show-list-popup' : ''
          }`}
          onClick={closeActionMask}
        />
        {myLeadsState.isPurchaseInProgress && currentTab === 0 && (
          <ProcessingMessage />
        )}
        {listView}
      </div>
      {archivedCount > 0 && (
        <div className="archived-contacts">
          <div className="archived-icon-wrapper">
            <ArchivedIcon />
          </div>
          <div className="archived-contacts-content">
            <span className="archived-content-first">
              We have archived the older contacts in your list.{' '}
            </span>
            <span className="archived-content-second">
              Please write to{' '}
              <a href="mailto:support@adapt.io">support@adapt.io</a>, if you
              want to access the archived contacts
            </span>
          </div>
        </div>
      )}
      <AddToListWithOptions />
    </div>
  );
});

export { ContactList };
export default ContactList;
